"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class Device extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.browser = null;
        this.tab = null;
    }
    schema() {
        return Device.schema;
    }
    subject() {
        return Device.subject;
    }
}
exports.Device = Device;
Device.subject = "device";
Device.schema = {
    "type": "record",
    "name": "Device",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "browser",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Browser",
                    "namespace": "storyblocks.common.frontend",
                    "fields": [
                        {
                            "name": "userAgent",
                            "type": "string"
                        },
                        {
                            "name": "language",
                            "type": "string"
                        },
                        {
                            "name": "platform",
                            "type": "string"
                        },
                        {
                            "name": "name",
                            "type": [
                                "null",
                                "string"
                            ],
                            "default": null
                        }
                    ]
                }
            ],
            "default": null
        },
        {
            "name": "tab",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Tab",
                    "namespace": "storyblocks.common.frontend",
                    "fields": [
                        {
                            "name": "isNewTab",
                            "type": "boolean"
                        },
                        {
                            "name": "tabCount",
                            "type": "int"
                        },
                        {
                            "name": "tabId",
                            "type": "string"
                        }
                    ]
                }
            ],
            "default": null
        },
        {
            "name": "navigation",
            "type": {
                "type": "record",
                "name": "Navigation",
                "namespace": "storyblocks.common.frontend",
                "fields": [
                    {
                        "name": "referrerUrl",
                        "type": "string"
                    },
                    {
                        "name": "navigationType",
                        "type": [
                            "null",
                            {
                                "type": "enum",
                                "name": "NavigationType",
                                "namespace": "storyblocks.common.enums",
                                "symbols": [
                                    "TYPE_NAVIGATE",
                                    "TYPE_RELOAD",
                                    "TYPE_BACK_FORWARD",
                                    "TYPE_RESERVED",
                                    "OUTDATED_SCHEMA"
                                ],
                                "default": "OUTDATED_SCHEMA"
                            }
                        ],
                        "default": null
                    }
                ]
            }
        }
    ]
};
//# sourceMappingURL=Device.js.map